module.exports = __webpack_public_path__ + "static/media/lightbeige.46f6800d.png";